export default {
    palette:{
        display: "flex",
        flexDirection: "column",
        height: "100vh",
    },
    paletteColors:{
        height:"90%",
    },
    
}